module.exports = __webpack_public_path__ + "img/smoke_status.ce6c37e5.svg";